"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const removeNonDigits = (string) => string ? string.replace(/\D/g, '') : '';
exports.default = removeNonDigits;
